import Application from "../../Application";
import DynamicQueriesPresenter, {
  IDynamicQueriesPresenter
} from "../../presenter/dynamicQuery/DynamicQueriesPresenter";
import { INotificationService } from "../../service/notification/NotificationService";
import { IDynamicQueryService } from "../../service/dynamicQuery/DynamicQueryService";
import { IDynamicQuery } from "../../model/dynamicQuery/DynamicQuery";

export default class ShowDynamicQueriesInteractor {
  private application: Application;
  private output?: IDynamicQueriesPresenter;
  private dynamicQueryService: IDynamicQueryService;
  private notificationService: INotificationService;

  constructor(application, dynamicQueryService, notificationService) {
    this.application = application;
    this.dynamicQueryService = dynamicQueryService;
    this.notificationService = notificationService;
  }

  async getDynamicQueries() {
    try {
      let dynamicQueries = await this.dynamicQueryService.getDynamicQueries();
      return dynamicQueries;
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute() {
    this.output = DynamicQueriesPresenter({
      application: this.application,
      initialState: { dynamicQueries: [] as IDynamicQuery[] }
    });

    this.getDynamicQueries().then(this.output?.setDynamicQueries);

    return this.output;
  }
}
